import { render, staticRenderFns } from "./employeeForgotPassword.vue?vue&type=template&id=48329e09&scoped=true"
import script from "./employeeForgotPassword.vue?vue&type=script&lang=js"
export * from "./employeeForgotPassword.vue?vue&type=script&lang=js"
import style0 from "./employeeForgotPassword.vue?vue&type=style&index=0&id=48329e09&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48329e09",
  null
  
)

export default component.exports